(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Tartib", [], factory);
	else if(typeof exports === 'object')
		exports["Tartib"] = factory();
	else
		root["Tartib"] = factory();
})(self, function() {
return 